import React from "react";
import { Spinner } from "react-bootstrap";
import "./loaderCenter.css";


const GlobalLoader = () => { 
    return (
        <div className="global-loader-div">
            <Spinner animation="border" />
        </div>
    );
}

export default GlobalLoader;
